var map = {
	"./Central-mobile.jpg": 1581,
	"./Mandurah-mobile.jpg": 1582,
	"./North-mobile.jpg": 1583,
	"./South-mobile.jpg": 1584,
	"./default-mobile.jpg": 1585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1580;